import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import TaskDetail from '../TaskDetail';
import styles from './HuddleTaskSheet.module.scss';

const HuddleTaskSheet = ({ onClose, taskDetailProps }) => {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className={styles.backdrop}>
      <button
        type="button"
        className={styles.backdropDismiss}
        aria-label="Close task view"
        onClick={onClose}
      />
      <div className={styles.panel} role="dialog" aria-modal="true">
        <TaskDetail {...taskDetailProps} onClose={onClose} />
      </div>
    </div>
  );
};

HuddleTaskSheet.propTypes = {
  onClose: PropTypes.func.isRequired,
  taskDetailProps: PropTypes.object.isRequired,
};

export default HuddleTaskSheet;
